import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, LogOut, Crown, Settings } from "lucide-react";
import { useAuth } from "@/lib/auth";
import LangToggle from "@/components/LangToggle";

const links = [
  { to: "/super-admin", icon: LayoutDashboard, label: "Dashboard", end: true, testId: "sa-nav-dashboard" },
  { to: "/super-admin/tenants", icon: Building2, label: "Tenants", testId: "sa-nav-tenants" },
  { to: "/super-admin/settings", icon: Settings, label: "Settings", testId: "sa-nav-settings" },
];

export default function SuperAdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  const onLogout = () => { logout(); nav("/login"); };

  return (
    <div className="min-h-screen bg-slate-100" data-testid="superadmin-layout">
      <header className="bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl gold-grad grid place-items-center text-slate-900">
              <Crown className="w-5 h-5" />
            </div>
            <div>
              <div className="font-extrabold tracking-tight text-base">SaaS Control Center</div>
              <div className="text-[11px] opacity-70">Super Admin · {user?.phone}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <LangToggle />
            <button data-testid="sa-logout" onClick={onLogout} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 text-[11px] font-bold uppercase tracking-wider">
              <LogOut className="w-3.5 h-3.5" /> Logout
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-2 sm:px-6 pt-3">
        <nav className="flex gap-1 overflow-x-auto scrollbar-hide bg-white rounded-2xl p-1.5 card-shadow border border-slate-100">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={({ isActive }) =>
                `min-w-[140px] inline-flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-xs font-bold whitespace-nowrap tap-scale ${
                  isActive ? "bg-slate-900 text-white shadow-md" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <l.icon className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 page-enter">
        <Outlet />
      </main>
    </div>
  );
}
